import { render, staticRenderFns } from "./ListaMovimientosPorEstatus.vue?vue&type=template&id=07db4ea0"
import script from "./ListaMovimientosPorEstatus.vue?vue&type=script&lang=js"
export * from "./ListaMovimientosPorEstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports